import { useContext } from "react";
import { DashboardContext } from "../../context/DashboardContext";

function ErrorPage(props) {

    const { title, subtitle, buttons, illustration } = props;
    const context = useContext(DashboardContext);

    return (
        <div>
            <div className={"fixed top-0"}>
                <div className="flex items-center justify-between p-6  min-w-full bg-transparent z-50">
                    <img alt="Psych Press Portal Logo" className="w-24" src={context.getImage("shortLogo")} />
                </div>
            </div>
            <div className={
                "mx-auto h-screen p-8 bg-gradient-to-l from-primary-100 to-secondary-100 grid grid-flow-row lg:items-center " +
                "lg:justify-center lg:grid-cols-2 lg:grid-flow-col"
            }>
                <div className={"flex items-center justify-center"}>
                    <img className={"2xl:w-3/5 xl:w-8/12 w-4/5"} alt="" src={illustration} />
                </div>
                <div className={"text-center lg:text-left"}>
                    <h1 className={"font-serif text-xl text-blue-gray-600 mb-3"}>
                        {title}
                    </h1>
                    <div className={"text-md text-blue-gray-500"}>
                        {subtitle}
                    </div>
                    <div className={"flex flex-row justify-center lg:justify-start gap-4 mt-6"}>
                        {buttons}
                    </div>
                </div>

            </div>
        </div>
    );
}

export default ErrorPage;
